import { PrimaryButton, SecondaryButton } from "@digipost/dds-buttons-react";
import { Modal, ModalActions } from "@digipost/dds-modal-react";
import React, { useEffect, useId, useState } from "react";
import { Outlet } from "react-router";

import { useEntrypointContext } from "../EntrypointContext";
import { applications } from "../env";
import Translated from "../infrastructure/components/Translated";
import { remove } from "../infrastructure/digipost-fetch";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import { useTranslate } from "../infrastructure/hooks/useTranslate";
import { findURIWithWindowHostname } from "../infrastructure/link";
import styles from "./LoginRedirectWrapper.module.less";

const removeCookie = (key: string): void => {
  const now = new Date();
  const path = "/";
  document.cookie = `${key}=;path=${path};expires=${now.toUTCString()}`;
};

function LoginRedirectWrapper(): React.ReactElement {
  const entrypoint = useEntrypointContext();
  const translate = useTranslate();
  const rootPath = useRootPath();
  const [showModal, setShowModal] = useState(false);
  const descriptionId = useId();

  const goToLoggedInPage = (): void => {
    window.location.href = applications[entrypoint.role];
  };

  const logout = (): void => {
    const logoutUrl =
      entrypoint.role === "PRIVAT"
        ? findURIWithWindowHostname("logout", entrypoint.link)
        : findURIWithWindowHostname("logout_idp", entrypoint.link);

    //utloggingskode kopiert fra postkasse
    remove(logoutUrl, entrypoint.csrfToken)
      .then(() => {
        document.cookie
          .split(";")
          .filter((item) => !item.includes("digipost.post.id"))
          .filter((item) => !item.includes("digipost.language"))
          .filter((item) => !item.includes("digipost.consent"))
          .forEach((item) => {
            const key = item.split("=")[0];
            removeCookie(key);
          });
      })
      .then(() => window.location.reload());
  };

  useEffect(() => {
    const isAlreadyLoggedIn = !!entrypoint && !!entrypoint.role;

    if (isAlreadyLoggedIn) {
      const loggedInIdporten =
        entrypoint.authenticationlevelIdporten === 103 ||
        entrypoint.authenticationlevelIdporten === 104;

      const loggedInPrivat =
        entrypoint.role === "PRIVAT" ||
        (entrypoint.role === "REGISTRERING" && loggedInIdporten);
      const loggedInVirksomhet =
        entrypoint.role === "VIRKSOMHET" ||
        (entrypoint.role === "REGISTRERING" && !loggedInIdporten);

      const loggedInWrongPath =
        (loggedInPrivat && location.pathname === `${rootPath}/business`) ||
        (loggedInVirksomhet && location.pathname === `${rootPath}/`);

      if (loggedInWrongPath) {
        setShowModal(true);
      } else {
        window.location.href = applications[entrypoint.role];
      }
    }
  }, [entrypoint]);

  return (
    <>
      <Modal
        ariaDescribedby={descriptionId}
        headingSize="large"
        isOpen={showModal}
        heading={translate("wrong_role.header")}
        showBottomModalOnSmallScreen={true}
        shouldCloseOnOverlayClick={false}
        onClose={() => setShowModal(false)}
        showCrossButton={false}
      >
        <p id={descriptionId} className={styles.modalParagraph}>
          <Translated
            textKey={
              entrypoint.role === "PRIVAT"
                ? "wrong_role.description_private"
                : "wrong_role.description_business"
            }
          />
        </p>
        <ModalActions>
          <PrimaryButton onClick={logout}>
            <Translated textKey={"generic.log_out"} />
          </PrimaryButton>
          <SecondaryButton onClick={goToLoggedInPage}>
            <Translated textKey={"wrong_role.stay_logged_in"} />
          </SecondaryButton>
        </ModalActions>
      </Modal>
      <Outlet />
    </>
  );
}

export default LoginRedirectWrapper;
